import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";

import { numberFormat } from "../../../../services/helpers";
import StringInput from '../../../common/table/StringInput';
import NumberInput from '../../../common/table/NumberInput';
import { selectDefTableSize } from '../../../../selectors/screenSelectors';

class StationTable extends Component {

    constructor(props){
        super(props);
        this.state = { };
    }

    render(){
        const { defaultPageSize } = this.props;
        return(
            <div className={`table-main-wrap ${!this.props.propsArray.length && this.props.propsGetDataStatus == 'pending' ? 'table-main-wrap_loading' : '' }`}>
                <div className="table-header">Інформація про АЗС</div>
                <ReactTable
                    pageSize={this.props.pageSize}
                    page={this.props.page}
                    onPageSizeChange={this.props.handleChangePageSize}
                    onPageChange={this.props.handleChangePage}
                    manual={true}
                    filterable
                    sortable
                    multiSort
                    onFilteredChange={this.props.handleOnFilterChange}
                    onSortedChange={this.props.handleOnSortChange}
                    filtered={this.props.filtered}
                    sorted={this.props.sorted}
                    pages={Math.ceil(this.props.count / this.props.pageSize)}
                    getTheadFilterThProps={(rowInfo) => {
                        return {
                            style: {
                                overflow: 'visible',
                                textAlign: 'left'
                            }
                        }
                    }}
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onClick: () => {
                                    this.props.propsRowClick({
                                        id: rowInfo.row._original.ID,
                                        index: rowInfo.index
                                    });
                                },
                                style: {
                                    backgroundColor: rowInfo.index === this.props.index ? '#B8B8B8' : 'white',
                                    color: rowInfo.index === this.props.index ? 'white' : 'black',
                                    cursor: 'pointer',
                                }
                            }
                        }else{
                            return {}
                        }
                    }}
                    data={this.props.propsArray}

                    columns={[
                        {
                            Filter: NumberInput,
                            minWidth: 200,
                            Header: 'ID',
                            id: "ID",
                            accessor: item => { return item.ID }
                        },
                        {
                            Filter: StringInput,
                            minWidth: 400,
                            Header: "Назва",
                            id: "Name",
                            accessor: row => `${row.Name || '-----------'}`
                        },
                        {
                            filterable: false,
                            sortable: false,
                            minWidth: 400,
                            Header: "Адреса",
                            id: 'Addresses',
                             accessor: item => {
                                return (`${ item.Addresses.map((item) => {return  (`${item.City.Name}, ${item.Street }`) }).join("; ") || '-----------'}`)
                            }
                        }
                    ]}
                    defaultPageSize={defaultPageSize}
                    className=" -highlight"
                    NoDataComponent={() => null}
                    previousText="Назад"
                    nextText="Вперед"
                    rowsText="рядків"
                    pageText="Сторінка"
                    ofText="з"
                />
                <div className="loading"></div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    defaultPageSize: selectDefTableSize(state),
});

export default connect(mapStateToProps)(StationTable)